/**
 * Created by Administrator on 2017-12-18.
 */
import { Message } from 'element-ui'
import * as _ from '@/common/js/config'

export function message(msg, isScuess) {
  if (isScuess) {
    Message.success({
      showClose: true,
      message: msg,
      duration: _.MESSAGE_DURATION
    })
  } else {
    Message.error({
      showClose: true,
      message: msg,
      duration: _.MESSAGE_DURATION
    })
  }
}

export function errMsg(err) {
  let [errStr, errCode] = [err.toString(), '']
  errCode = errStr.substring(errStr.length - 3)
  message(`${errCode},程序员开了个小差，请刷新后尝试`, false)
}



// WEBPACK FOOTER //
// ./src/common/js/messages.js